const moment = require('moment')
export function	formatDate(value, format) {
	if (!value) {
		return '';
	}
  return moment(value).format(format)
}